import { IOptionPickerTextItem } from '@vfde-brix/ws10/option-picker';
import { SUFFIX_BANDWIDTH } from '../../constants';
import { JarvisProduct } from '@vfde-sails/avc-core';

export const getTariffItem = (
    tariff: JarvisProduct,
    isEnabled: boolean,
    selectedId?: string
): IOptionPickerTextItem => ({
    stdValue: tariff.id,
    stdPrimaryLabel: tariff.download,
    stdSecondaryLabel: SUFFIX_BANDWIDTH,
    optChecked: isEnabled && (tariff.id === selectedId),
    optDisabled: !isEnabled,
});
